<template>
    <div>
    <div class="form-ctrl">
        <label class="container">
          <small v-html="label"></small>
          <input type="checkbox" :id="id" :checked="value"  v-on:change="updateCheckbox(!value)"/>
          <span class="checkmark"></span>
        </label>
    </div>
    <div class="invalid" v-if="error">
        {{errorMessage}}
    </div>
    </div>
</template>

<script>
    export default {
        props:{
            id:{
                type:String
            },
            value:{
                type:Boolean
            },
            label:{
                type:String,
                required:true
            },
            required:{
                type:Boolean,
                default:false
            },
            error:{
                type:Boolean,
                default:false
            },
            errorMessage:{
                type:String
            }
        },

        methods:{
            updateCheckbox(checked){
                this.$emit('input', checked)
            }
        }
    }
</script>

<style lang="scss" scoped>
 /* The container */
  .container {
    display: block;
    position: relative;
    padding-left: 20px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 13px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    small {
      font-size: 13px;
    }
  }
 .invalid {
     color: red;
     font-size: 12px;
     margin-top: 3px;
 }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 10px;
    width: 10px;
    background-color: #eee;
    border: 1px solid #ccc;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: #fff;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 3px;
    top: -5px;
    width: 4px;
    height: 10px;
    border: solid #FFD100;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
</style>